/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Document controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetDocumentsResponse, UploadDocumentResponse, MoveDocumentFolderRequest, GetDocumentByIdResponse } from "../models";

@Injectable({ providedIn: "root" })
export class DocumentService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getDocuments(folderId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetDocumentsResponse>;
    getDocuments(folderId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetDocumentsResponse>>;
    getDocuments(folderId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetDocumentsResponse>>;
    getDocuments(folderId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Document`;

        let params = new HttpParams();
        if (folderId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, folderId, 'folderId');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    uploadDocument(file: Blob, folderId?: number | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<UploadDocumentResponse>;
    uploadDocument(file: Blob, folderId?: number | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UploadDocumentResponse>>;
    uploadDocument(file: Blob, folderId?: number | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UploadDocumentResponse>>;
    uploadDocument(file: Blob, folderId?: number | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Document`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (folderId !== undefined) {
            formData.append('folderId', String(folderId));
        }
        if (file !== undefined) {
            formData.append('file', file);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, formData, requestOptions);
    }

    moveDocumentFolder(moveDocumentFolderRequest: MoveDocumentFolderRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    moveDocumentFolder(moveDocumentFolderRequest: MoveDocumentFolderRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    moveDocumentFolder(moveDocumentFolderRequest: MoveDocumentFolderRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    moveDocumentFolder(moveDocumentFolderRequest: MoveDocumentFolderRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Document/MoveDocumentFolder`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.patch(url, moveDocumentFolderRequest, requestOptions);
    }

    getDocumentById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetDocumentByIdResponse>;
    getDocumentById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetDocumentByIdResponse>>;
    getDocumentById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetDocumentByIdResponse>>;
    getDocumentById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Document/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    deleteDocument(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteDocument(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteDocument(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteDocument(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Document/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    downloadDocument(id: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    downloadDocument(id: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    downloadDocument(id: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    downloadDocument(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Document/${id}/download`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            responseType: 'blob' as 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
